import React from 'react'
import type { TableBodyTypeMap } from '@material-ui/core/TableBody'
import MuiTableBody from '@material-ui/core/TableBody'
import type { OverridableComponent } from '@material-ui/core/OverridableComponent'

const TableBody: OverridableComponent<TableBodyTypeMap> = (props: any) => <MuiTableBody component="div" {...props} />

export default TableBody
